import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Icon from '../Icon';

// technically all we really need is to set the props to 
// "React.ComponentPropsWithoutRef<typeof Svg>", but in order for our custom
// props to come through in Storybook we need to bring them up again here 

export default function CheckIcon(_ref) {
  let {
    contextType = 'image',
    className = '',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 40 40"
  }, props, {
    contextType: contextType,
    className: `pi pi-check-icon ${className}`
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.2 12.47c0-.62-.2-1.13-.6-1.53l-3.03-3c-.42-.42-.92-.64-1.5-.64s-1.08.21-1.5.64L16.96 21.5l-7.53-7.53c-.42-.42-.92-.63-1.5-.63s-1.08.21-1.5.63l-3.03 3c-.4.4-.6.91-.6 1.53 0 .6.2 1.1.6 1.5l12.07 12.07c.42.42.92.64 1.5.64.6 0 1.11-.21 1.54-.64l18.1-18.1c.39-.4.59-.9.59-1.5z"
  })));
}